module.exports = __webpack_public_path__ + "media/images/newProjectDashboardImage-9104739b.png";